import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function CodehookPromptNode({ id, data }) {
    return (
        <NodeComponent title="Codehook" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

